import { Paragraph } from "@sicredi/react";
import { IButtonTabComponent } from "./model";
import styles from "./index.module.scss";

export const ButtonTabComponent: React.FC<IButtonTabComponent> = ({
  text,
  onClick,
  isParametroBens,
}) => {
  const buttonColorFocus = "3px solid #33820d";
  const buttonColorBlur = "2px solid #cdd3cd40";
  return (
    <div className={styles.container}>
      <button
        onClick={onClick}
        className={styles.button_tab}
        style={{
          borderBottom: isParametroBens ? buttonColorFocus : buttonColorBlur,
        }}
      >
        <Paragraph
          weight={isParametroBens ? "bold" : "light"}
          className={styles.text_button_tab}
        >
          {text}
        </Paragraph>
      </button>
    </div>
  );
};
